"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.masksAreEqual = masksAreEqual;
exports.defaultMaskObject = void 0;

var _mask = require("@blue/services/utils/mask");

function masksAreEqual(m1, m2) {
  if (m1.length !== m2.length) return false;

  for (var i = 0, j = 0; i < m1.length; ++i, ++j) {
    if (m1[i] !== m2[j]) return false;
  }

  return true;
}

var defaultMaskObject = (0, _mask.createMask)([]);
exports.defaultMaskObject = defaultMaskObject;
